import React from "react";
import styles from "./services.module.css";
import { TextComponent } from "../../../../../components";

const services = [
  "Wedding Photographer",
  "Engagement Photographer",
  "Portrait Photographer",
  "Event Photographer",
];

function Services({ details }) {
  return (
    <div className={styles.mainDiv}>
      <TextComponent text={"Services Provide"} textClass={styles.textHeading} />
      {/* {services.map((data) => ( */}
      <TextComponent
        service
        text={
          details?.business_info?.service_offer
            ? details?.business_info?.service_offer
            : details?.service
            ? details?.service
            : "--"
        }
        textClass={styles.servText}
      />
      {/* ))} */}
      {/* <TextComponent
        text={"Pricing - $50.00 Per Day"}
        textClass={styles.textHeading}
      />
      <TextComponent text={"Photo + Video"} textClass={styles.textHeading} /> */}
    </div>
  );
}

export default Services;
